import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useJoinWithoutInvitationDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContent: {
            margin: theme.spacing(4, 4),
        },
        actions: {
            padding: theme.spacing(4, 4),
        },
    }),
);

export default useJoinWithoutInvitationDialogStyles;
